// Counter of result.
function loadCounterResult() {
    if (jQuery('.items-counter').is('div') && jQuery('.items-counter:hidden').is('div') === false) {
        var total_items = jQuery('.list-item:not(:hidden)').length;
        if (total_items === 0) {
            jQuery('.items-counter').show().html('No results');
            return;
        }
        let current_page = location.hash.replace('#', '');
        current_page = (current_page !== "") ? current_page : 'page-1';
        var items_page = jQuery('.list-item').filter('.' + current_page);
        var items_page_count = items_page.length;
        var first_item = last_item = 0;
        // first and last item of current page.
        if (items_page_count !== 0) {
            first_item = jQuery(items_page[0]).attr('class').toString().match(/item\-([0-9]*)/);
            first_item = first_item[1];
            last_item = jQuery(items_page[items_page.length - 1]).attr('class').toString().match(/item\-([0-9]*)/);
            last_item = last_item[1];
        }
        jQuery('.items-counter').show().html(first_item + '-' + last_item + ' results on ' + total_items + ' results');
    }
}

function reorderListResult(item_per_page = 5) {
    // Reset page.
    location.hash = "page-1";

    var items_not_hidden = jQuery('.list-item:not(:hidden)');
    jQuery('.list-item').removeClass(function () {
        let number = jQuery(this).attr('class').toString().match(/item\-[0-9]*/);
        return number != null ? number[0] : "";
    }).removeClass(function () {
        let number = jQuery(this).attr('class').toString().match(/page\-[0-9]*/);
        return number != null ? number[0] : "";
    });

    if (items_not_hidden.length > 0) {
        let counter = 1;
        for (const item of items_not_hidden) {
            jQuery(item).addClass('item-' + counter);
            counter = counter + 1;
        }
    }

    // set pages
    var items_not_hidden_chunked = chunk(items_not_hidden, item_per_page);
    var page_num = 1;
    for (var page of items_not_hidden_chunked) {
        for (var item of page) {
            jQuery(item).addClass("page-" + page_num);
        }
        page_num = page_num + 1;
    }
}

function reloadListItems(nb_items = 20, scrollSpeed = 'slow', activeScroll = true) {
    var filterTags = jQuery('#container-system-element input:checkbox:checked');
    if(filterTags.length > 0){
        jQuery(".panel-body .reset").show();
    }
    reorderListResult(nb_items);
    loadCounterResult();
    loadPagination(null, null, nb_items, scrollSpeed, activeScroll);
}

var paginationLoadItems = function (listItems = '.list-item') {
    let current_page = location.hash.replace('#', '');
    current_page = (current_page !== "") ? current_page : 'page-1';
    jQuery(listItems).css({
        'position': 'absolute',
        'left': "-9999px"
    }).filter('.' + current_page).css({
        'position': 'unset',
        'left': "unset"
    });
};

var Pagination = {

    code: '',

    // --------------------
    // Utility
    // --------------------

    // converting initialize data
    Extend: function (data) {
        data = data || {};
        Pagination.size = data.size || 1;
        Pagination.page = data.page || 1;
        Pagination.step = data.step || 3;
        Pagination.items = data.items || [];
        Pagination.refreshItems = data.refeshFn || function () {
        };
        Pagination.refeshCounter = data.refeshCounter || function () {
        };
        Pagination.scrollSpeed = data.scrollSpeed !== null || data.scrollSpeed !== undefined || data.scrollSpeed !== '' ? data.scrollSpeed  : 'slow';
        Pagination.activeScroll = data.activeScroll !== null || data.activeScroll !== undefined || data.activeScroll !== '' ? data.activeScroll  : true;
   },

    // add pages by number (from [s] to [f])
    Add: function (s, f) {
        for (var i = s; i < f; i++) {
            Pagination.code += '<a>' + i + '</a>';
        }
    },

    // add last page with separator
    Last: function () {
        Pagination.code += '<i>...</i><a>' + Pagination.size + '</a>';
    },

    // add first page with separator
    First: function () {
        Pagination.code += '<a>1</a><i>...</i>';
    },


    // --------------------
    // Handlers
    // --------------------

    // change page
    Click: function (e) {
        e.preventDefault();
        Pagination.page = +this.innerHTML;
        Pagination.Start();
    },

    // previous page
    Prev: function (e) {
        e.preventDefault();
        Pagination.page--;
        if (Pagination.page < 1) {
            Pagination.page = 1;
        }
        Pagination.Start();
    },

    // next page
    Next: function (e) {
        e.preventDefault();
        Pagination.page++;
        if (Pagination.page > Pagination.size) {
            Pagination.page = Pagination.size;
        }
        Pagination.Start();
    },


    // --------------------
    // Script
    // --------------------

    // binding pages
    Bind: function () {
        var a = Pagination.e.getElementsByTagName('a');
        for (var i = 0; i < a.length; i++) {
            if (+a[i].innerHTML === Pagination.page) a[i].className += '  active current';
            a[i].addEventListener('click', Pagination.Click, false);
        }
    },

    // write pagination
    Finish: function () {
        location.hash = "page-" + Pagination.page;
        Pagination.refreshItems();
        Pagination.refeshCounter();
        Pagination.e.innerHTML = Pagination.code;
        Pagination.code = '';
        Pagination.Bind();
        // Todo move out this function
        if(Pagination.activeScroll === true) {
            jQuery('.pagination a').on('click', function () {
                jQuery('html,body').animate({scrollTop: jQuery('.component-list-body').offset().top - 200}, Pagination.scrollSpeed);
            });
        }
    },

    // find pagination type
    Start: function () {
        if (Pagination.size < Pagination.step * 2 + 6) {
            Pagination.Add(1, Pagination.size + 1);
        } else if (Pagination.page < Pagination.step * 2 + 1) {
            Pagination.Add(1, Pagination.step * 2 + 4);
            Pagination.Last();
        } else if (Pagination.page > Pagination.size - Pagination.step * 2) {
            Pagination.First();
            Pagination.Add(Pagination.size - Pagination.step * 2 - 2, Pagination.size + 1);
        } else {
            Pagination.First();
            Pagination.Add(Pagination.page - Pagination.step, Pagination.page + Pagination.step + 1);
            Pagination.Last();
        }
        Pagination.Finish();
    },

    // --------------------
    // Initialization
    // --------------------

    // binding buttons
    Buttons: function (e) {
        var nav = e.getElementsByTagName('a');
        nav[0].addEventListener('click', Pagination.Prev, false);
        nav[1].addEventListener('click', Pagination.Next, false);
    },

    // create skeleton
    Create: function (e) {

        var html = [
            '<a>Previous</a>', // previous button
            '<span></span>',  // pagination container
            '<a>Next</a>'  // next button
        ];

        e.innerHTML = html.join('');
        Pagination.e = e.getElementsByTagName('span')[0];
        Pagination.Buttons(e);
    },

    // init
    Init: function (e, data) {
        Pagination.Extend(data);
        if (Pagination.size > 1) {
            Pagination.Create(e);
            Pagination.Start();
        } else {
            e.innerHTML = '';
            Pagination.refreshItems();
        }
        location.hash = "page-1";
    }
};

/* * * * * * * * * * * * * * * * *
* Init of pagination
* * * * * * * * * * * * * * * * */
var loadPagination = function (element, list, item_per_page = 5, scrollSpeed = 'slow', activeScroll = true) {
    if (element === null || element === undefined) {
        element = document.querySelector('.pagination');
    }
    if (list === null || list === undefined) {
        list = document.querySelectorAll('.list-item');
    }
    // Get also not hidden item.
    list = Object.entries(list).filter(item => item[1].style.display != 'none');
    let current_page = location.hash.replace('#', '').match(/page\-([0-9])*/);
    nbPages = Math.ceil(list.length / item_per_page);
    options = {
        size: nbPages,
        page: current_page != null ? parseInt(current_page[1]) : 1,
        step: 1,
        refeshFn: paginationLoadItems,
        refeshCounter: loadCounterResult,
        scrollSpeed : scrollSpeed,
        activeScroll : activeScroll
    };
    Pagination.Init(element, options);
};

function addFilterTag(container, text, value) {
    var wrapper = document.querySelector(container);
    var tag = document.createElement("div");
    tag.className = "tag tag-" + text;
    tag.setAttribute('data-checkbox', value);
    tag.innerHTML = '<span class="tag-text">' + text + '</span><button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&#120;</span></button>';
    tag.addEventListener('click', function () {
        let value = this.getAttribute('data-checkbox');
        jQuery('input[value=' + value + ']').click();
        this.remove();
    });
    wrapper.appendChild(tag);
}

// Exportation des fonctions dans window
window.loadCounterResult = loadCounterResult;
window.reorderListResult = reorderListResult;
window.reloadListItems = reloadListItems;
window.paginationLoadItems = paginationLoadItems;
window.Pagination = Pagination;
window.loadPagination = loadPagination;
window.addFilterTag = addFilterTag;

